import {Component, Input} from '@angular/core';
import {ConnectionType} from "@flowmaps-com/flowmaps-typescriptmodels";
import {EntityType} from "../../../../handlers/entity";
import {RefdataUtils} from "../../../refdata/refdata-utils";
import {SourceInfo, SourcesProvider} from "../../../../utils/source-providers/sources-provider";
import {bestLocationEnergyLabel} from '../../../common/energy-label/energy-label.component';

@Component({
    selector: 'app-quarterly-report-html-front-page',
    templateUrl: './quarterly-report-html-front-page.component.html',
    styleUrls: ['./quarterly-report-html-front-page.component.scss']
})
export class QuarterlyReportHtmlFrontPageComponent {
    @Input() logoPath: string;
    @Input() sourcesProvider: SourcesProvider<any>;
    @Input() quarterLabel: string;
    @Input() reportingWindowLabel: string;
    @Input() location: SourceInfo;
    @Input() locationImagePath: string;

    get organisation(): SourceInfo {
        return this.sourcesProvider?.getAllSourcesByType(EntityType.organisation)?.[0];
    }

    get locationEntity() {
        return this.location?.source?.location;
    }

    get locationName(): string {
        return this.locationEntity?.info?.name;
    }

    get locationAddress(): string {
        return RefdataUtils.addressFormatter(this.locationEntity?.info?.address);
    }

    get addressLine(): string {
        const address = this.locationEntity?.info?.address;
        return address ? `${address.street || ""} ${address.number || ""} ${address.addition || ""}`.trim() : null;
    }

    get cityLine(): string {
        const address = this.locationEntity?.info?.address;
        return address ? `${address.zipCode || ""} ${address.city || ""}`.trim() : null;
    }

    get areaLabel(): string {
        const area = this.locationEntity?.info?.area;
        return area ? `${area} m2` : null;
    }

    get energyLabel(): string | null {
        return bestLocationEnergyLabel(this.locationEntity);
    }

    get eanElectricity(): string {
        return this.connectionCodeForType(ConnectionType.Electricity);
    }

    get eanGas(): string {
        return this.connectionCodeForType(ConnectionType.Gas);
    }

    get eanHeat(): string {
        return this.connectionCodeForType(ConnectionType.Heat);
    }

    private connectionCodeForType(type: ConnectionType): string {
        return this.sourcesProvider?.getAllSourcesByType(EntityType.connection)
            ?.find(connection => connection.connectionType === type)?.source?.connection?.info?.code;
    }
}
